<!-- START Emergency Contact form -->
<form
	[formGroup]="form"
	class="sidebar__form {{ formClassDisplayModeView }}">

	<h2 class="pax-title-h2">{{'bookingDetails.titles.emergencyContact' | ibeadmin:'sync'}}</h2>
	<p class="muted bottom-gap">
		{{'bookingDetails.text.tapEmergencyInfoMessage' | ibeadmin:'sync'}}
	</p>

	<div class="form--edit-mode" *ngIf="displayMode === 'edit'">
		<div class="form-field--row">
			<div class="form-field">
				<app-checkbox-input-indra
					formControlName="declined"
					label="{{'bookingDetails.text.incaseOfEmergency' | ibeadmin:'sync'}}">
				</app-checkbox-input-indra>
			</div>
		</div>

		<div class="form-field--row grid no-padding" *ngIf="!form.controls['declined'].value">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="emergency-contact-name">
					{{'bookingDetails.label.firstNameLastName' | ibeadmin:'sync'}}
				</label>
				<input
					class="input-text"
					formControlName="emName"
					id="emergency-contact-name"
					maxlength="51"
				/>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formEmergencyContactErrors('emName') | ibeadmin: 'sync'"
					*ngIf="form.controls['emName'].invalid && displayValidationMessages"
				>{{ formEmergencyContactErrors('emName') | ibeadmin: 'sync' }}</span>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12">
				<app-select-input-indra
					selectId="selectCountryOfResidence"
					placeholder="{{'bookingDetails.label.selectCountryOfResidence' | ibeadmin:'sync'}}"
					formControlName="emCountry"
					id="emergency-contact-country"
					[options]="countryCodesCodeOpts"
					[optionsTranslated]="true"
					selectLabel="{{'bookingDetails.alt.selectCountryOfResidence' | ibeadmin: 'sync'}}"
					label="{{'bookingDetails.label.countryOfResidence' | ibeadmin:'sync'}}"
				>
				</app-select-input-indra>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formEmergencyContactErrors('emCountry') | ibeadmin:'sync'"
					*ngIf="form.controls['emCountry'].invalid && displayValidationMessages"
				>{{ formEmergencyContactErrors('emCountry') | ibeadmin:'sync' }}</span>

			</div>
		</div>

		<div class="form-field--row grid no-padding" *ngIf="!form.controls['declined'].value">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="emergency-contact-phone-country">
					{{'bookingDetails.label.phoneNumber' | ibeadmin:'sync'}}
				</label>
				<app-select-input-indra
					selectId="selectCountryCode"
					placeholder="{{'bookingDetails.label.selectCountryCode' | ibeadmin:'sync'}}"
					formControlName="emPrefix"
					id="emergency-contact-phone-country"
					[options]="countryCodesPrefixOpts"
					[optionsTranslated]="true"
					selectLabel="{{'bookingDetails.alt.selectCountryCode' | ibeadmin: 'sync'}}"
				>
				</app-select-input-indra>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formEmergencyContactErrors('emPrefix') | ibeadmin: 'sync'"
					*ngIf="form.controls['emPrefix'].invalid && displayValidationMessages" >
					{{ formEmergencyContactErrors('emPrefix') | ibeadmin: 'sync' }}
				</span>
			</div>

			<div class="form-field col-6 col-tp-6 col-p-12">
				<input
					type="text"
					id="emergency-contact-phone-number"
					class="input-text"
					placeholder="{{'bookingDetails.label.insertPhoneNumber' | ibeadmin:'sync'}}"
					formControlName="emPhone" 
					maxlength="11"
				/>
				<span aria-live="polite" [attr.aria-label]="formEmergencyContactErrors('emPhone') | ibeadmin: 'sync'" class="input-error" role="alert"
					*ngIf="form.controls['emPhone'].invalid && displayValidationMessages" >
					{{ formEmergencyContactErrors('emPhone') | ibeadmin: 'sync' }}
				</span>
			</div>
		</div>
		<a class="link right-gap" href="javascript:;" (click)="clearForm()"
			*ngIf="!isBookingPaymentPage && (hasChanges | async) && displayMode === 'edit'">
			{{'bookingDetails.label.clearDetails' | ibeadmin:'sync'}}</a>

		<a class="link" href="javascript:;" (click)="cancelEdit()"
			*ngIf="!isBookingPaymentPage && (hasChanges | async) && displayMode === 'edit'">
			{{'bookingDetails.label.cancelEditing' | ibeadmin:'sync'}}
		</a>
		
		<hr class="separator">
	</div>

	<div class="form--view-mode" *ngIf="displayMode === 'view' && form.value">
		<p *ngIf="(displayMode === 'view' && form.controls['declined'].value)"
			class="bold">
			{{'bookingDetails.label.noOneEmergency' | ibeadmin:'sync'}}
		</p>

		<div class="form-field--row grid no-padding" *ngIf="!form.controls['declined'].value">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.firstNameLastName' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.emName }}</span>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.countryOfResidence' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.emCountry | countryDesc }}</span>
			</div>
		</div>
		<div class="form-field--row grid no-padding" *ngIf="!form.controls['declined'].value">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.phoneNumber' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.emPhone }}</span>
			</div>
		</div>
	</div>
	<button class="button button-main-line top-gap" (click)="openEditForm()"
		*ngIf="displayMode === 'view'">
		{{ 'bookingDetails.text.editEmergencyContact' | ibeadmin:'sync' }}
	</button>
</form>
<!-- END Emergency Contact form -->
